import React, { Component} from 'react';
import FacebookProvider, { Login } from 'react-facebook';

class FacebookLogin extends Component {
    handleResponse = (data) => {
        console.log(data.tokenDetail.accessToken);
        console.log(data.tokenDetail);
        console.log(data.tokenDetail.signedRequest);

        data = { accessToken: data.tokenDetail.accessToken, type: 'fb'};

        window.AvaCAS.loginSocial(data)
            .then(
                (data) => {
                    console.log(data);
                    console.log('FB logged OK');
                    this.props.progressStopHandler();
                    this.props.redirectHandler(data);
                },
                (error) => {
                    this.setState({
                        inProgress: false,
                        loginError: 'FB login data incorrect',
                    });
                }
            );
    };

    handleError = (error) => {
        this.setState({ error });
    };

    onClick = () => {
        this.props.progressHandler();
    };

    render() {
        return (
            <FacebookProvider appId={this.props.facebookAppId}>
                <Login
                    scope="email"
                    onResponse={this.handleResponse}
                    onError={this.handleError}
                    render={({ isLoading, isWorking, onClick }) => (
                        <button className={"loginBtn loginBtn--facebook"} onClick={onClick}>LOGIN WITH FACEBOOK</button>
                    )}
                />
            </FacebookProvider>
        );
    }
}

export default FacebookLogin;


// WEBPACK FOOTER //
// ./src/components/FacebookLogin/FacebookLogin.js